/********************************************************/
/*                     PlaceTools                       */
/*           Used to create a copy of any asset         */
/*           and move it with the mouse, then on        */
/*           pointerup, stop moving the object          */
/********************************************************/

/* To use */
/* Make a new instance of PlaceTools in create() in the scene
/* and place InUpdate in the update loop of the scene (could possibly be changed to an ondelay).
/* Lastly, call CreateCopy() in the pointerdown method of the clickable asset to be copied 

/* Notes: scope of pointerdown is the object the pointer is down on.
/* Make sure to use this.scene.PlaceTools.CreateCopy in pointerdown function */

export default class PlaceTools
{
    constructor(scene,PointerUpFunction = true)
    {
        this.scene = scene;
        this.MoveThis = "null";
        this.PointerUpArguements;

        //This creates the listener for placeing the objects. Any on place calls should be put here
        this.scene.input.on('pointerup',()=>
        {
            if(this.MoveThis != "null")
            {
                if(PointerUpFunction != true)
                {
                    PointerUpFunction(this.MoveThis,this.PointerUpArguements);
                }
                this.MoveThis = "null";
            }
        });  
    }
   
    CreateCopy(Asset,Pointer,PointerUpArguements,IndividualModifiers = 'null') //Should Be Called On 'pointerdown'
        {
            var Temp;
            var Modifiers;

            this.PointerUpArguements = PointerUpArguements;

            Temp = this.scene.addImage(Pointer.x,Pointer.y,Asset.frame.name);

            if (IndividualModifiers != 'null')
            {
                Modifiers = Object.keys(IndividualModifiers);

                Modifiers.forEach((key)=>
                {
                    Temp[key] = IndividualModifiers[key];
                })
            }

            if(this.MoveThis != "null")
            {
                this.MoveThis.destroy();
            }
            
            this.MoveThis = Temp;
            

            return Temp;
        }

      CreateCopyText(Asset,Pointer,PointerUpArguements,IndividualModifiers = 'null') //Should Be Called On 'pointerdown'
        {
            var Temp;
            var Modifiers;

            this.PointerUpArguements = PointerUpArguements;

            Temp = this.scene.add.text(Pointer.x, Pointer.y, Asset.text, Asset.style).setOrigin(0.5).setPadding(5,5);

            if (IndividualModifiers != 'null')
            {
                Modifiers = Object.keys(IndividualModifiers);

                Modifiers.forEach((key)=>
                {
                    Temp[key] = IndividualModifiers[key];
                })
            }

            if(this.MoveThis != "null")
            {
                this.MoveThis.destroy();
            }
            
            this.MoveThis = Temp;
            

            return Temp;
        }

    InUpdate(Pointer)
        {
            if (this.MoveThis != "null")
            {
                this.MoveThis.x = Pointer.x;
                this.MoveThis.y = Pointer.y;
            }
        }

    DrawWithShape(pointer,RenderTexture,ShapeToDraw)
        {    
            var points;
            var DrawLog;
    
            points = pointer.getInterpolatedPosition(15);
    
            for(let x in points)
            {
                DrawLog = RenderTexture.draw(ShapeToDraw, points[x].x-RenderTexture.x, points[x].y-RenderTexture.y);
            }
            
            return DrawLog;
        }

}